const MomentInitializer = require('./moment-initializer');

module.exports = { MomentInitializer };
